// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Flash from "../../components/common/flash_message_component/flash_controller";
application.register("flash", Flash)

import Modal from "../../components/common/modal_component/modal_controller";
application.register("modal", Modal)

import Confetti from "./confetti_controller"
application.register("confetti", Confetti)

import ReadMore from '@stimulus-components/read-more'
application.register('read-more', ReadMore)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
